import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import changeManager from './plugins/changemanager'
import teamData from '@data/team.json'
import playerData from '@data/players.json'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    gameIsWonByTeam: null,
    tableID: null,
    turnID: 0,
    pawns: [],
    teams: teamData,
    players: playerData,
    boardX: 0,
    boardY: 0,
    boardZoomFactor: 1,
    yourTurn: false,
    breaths: {
      playerBreathAmount: [0, 0, 0, 0],
      teamA: {
        hasBreathed: false,
        amount: 0,
      },
      teamB: {
        hasBreathed: false,
        amount: 0,
      },
    },
  },
  actions,
  mutations,
  getters,
  plugins: [
    changeManager,
  ],
}

export default new Vuex.Store<RootState>(store)
